<template>
  <div>
    <v-scroll-y-transition mode="out-in">
      <chip-status-click
        v-if="!loading"
        :status="status"
        @click="openModalForm(row.id)"
      />
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      />
    </v-scroll-y-transition>
  </div>
</template>

<script>
import StatusSituationContratacoesEnum from 'Support/enums/StatusSituationContratacoesEnum';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';
import ChipStatusClick from 'Support/components/chips/ChipStatusClick.vue';
import NotificationMixin from 'Support/mixins/notification-mixin';
import RouterMixin from 'Support/mixins/router-mixin';

export default {
  name: 'CustomersStatusDataTableColumn',
  components: {
    ChipStatusClick,
  },
  mixins: [NotificationMixin, RouterMixin, PageableMixin],
  props: {
    value: {
      type: String,
      required: true,
    },
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      statusContratacao: StatusSituationContratacoesEnum,
      loading: false,
    };
  },
  computed: {
    status() {
      return this.value;
    },
  },
  created() {
    this.statusSelected = this.row.status;
  },
};
</script>
